document.addEventListener('DOMContentLoaded', function () {
  function patchHeaderMenu() {
    const headerMenu = document.querySelector('header-menu');
    if (!headerMenu) {
      setTimeout(patchHeaderMenu, 500);
      return;
    }

    let closeTimer = null;

    function isPointerInsideMenuArea(x, y) {
      // 检查鼠标是否在 header-menu 组件范围内
      const headerRect = headerMenu.getBoundingClientRect();
      if (x >= headerRect.left && x <= headerRect.right &&
          y >= headerRect.top && y <= headerRect.bottom) {
        return true;
      }

      // 检查所有展开的子菜单（它们可能超出 header 范围向下展开）
      const submenus = headerMenu.querySelectorAll('[ref="submenu[]"]');
      for (const submenu of submenus) {
        const rect = submenu.getBoundingClientRect();
        if (rect.width === 0 && rect.height === 0) continue;
        if (x >= rect.left && x <= rect.right &&
            y >= rect.top && y <= rect.bottom) {
          return true;
        }
      }

      return false;
    }

    // 全局监听鼠标移动，判断是否离开整个菜单区域
    document.addEventListener('pointermove', function (e) {
      const headerComponent = headerMenu.closest('header-component');
      if (!headerComponent) return;

      // 当前有展开的菜单项时才处理
      if (headerMenu.ariaExpanded !== 'true') return;

      if (!isPointerInsideMenuArea(e.clientX, e.clientY)) {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          // 再次确认鼠标仍在区域外
          if (!isPointerInsideMenuArea(e.clientX, e.clientY)) {
            // 触发原生 deactivate
            const activeItem = headerMenu.querySelector('[aria-expanded="true"][ref="menuitem"]');
            if (activeItem) {
              activeItem.dispatchEvent(new PointerEvent('pointerleave', { bubbles: true, relatedTarget: document.body }));
            }
            // 直接重置状态
            headerComponent.style.setProperty('--submenu-height', '0px');
            headerComponent.style.setProperty('--full-open-header-height', '0px');
            headerMenu.style.setProperty('--submenu-opacity', '0');
            headerMenu.ariaExpanded = 'false';
            if (activeItem) activeItem.ariaExpanded = 'false';
          }
        }, 200);
      } else {
        clearTimeout(closeTimer);
      }
    });

    // 同时阻止原生的 pointerleave 触发关闭
    const originalDeactivate = headerMenu.deactivate?.bind(headerMenu);
    if (originalDeactivate) {
      headerMenu.deactivate = function (event) {
        // 不立即关闭，交给 pointermove 全局检测处理
        return;
      };
    }
  }

  setTimeout(patchHeaderMenu, 900);
});
